import { render, staticRenderFns } from "./vModalFull.vue?vue&type=template&id=0de6d729&scoped=true"
import script from "./vModalFull.vue?vue&type=script&lang=js"
export * from "./vModalFull.vue?vue&type=script&lang=js"
import style0 from "./vModalFull.vue?vue&type=style&index=0&id=0de6d729&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de6d729",
  null
  
)

export default component.exports